const pl = {
  layout: {
    cos_button: {
      phone: 'Telefon',
      update_phone_number_message: 'Numer telefonu został pomyślnie zaktualizowany!'
    },
    time: {
      days: 'Dni',
      hours: 'Godzin',
      mins: 'Minut',
      secs: 'Sekund',
      starts: 'Rozpocznij',
      starts_immediately: 'Natychmiast rozpocznij'
    },
    field: {
      host: 'Prowadzący'
    },
    copy: 'Kopiuj'
  },
  validations: {
    email: 'adres e-mail musi być potwierdzony',
    phone: 'telefon musi być potwierdzony',
    required_field: 'to pole jest wymagane'
  },
  mailer: {
    need_help: 'Potrzebujesz pomocy?',
    stop_reminders: 'Nie chce otrzymywać powiadomień',
    cancel_registration: 'Anuluj rejestracje',
    report_abuse: 'Zgłoś nadużycie'
  },
  datetime: {
    no_sessions: 'Brak dostępnych sesji',
    empty_label: 'Data/godzina'
  },
  errors: {
    verification_failed: 'Weryfikacja nie powiodła się. Spróbuj ponownie.',
    session_unavailable: 'Wybrany termin nie jest już dostępny. Wybierz inny termin sesji.',
    challenge_email_mismatch:
      'Zarejestruj się przy użyciu tego samego adresu e-mail, którego użyto do rejestracji na wydarzenie.'
  }
}

export default pl
